import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
/* src/app/layout.sidebar/view.scss: no such file or directory */`],
})
export class LayoutSidebarComponent implements OnInit {
    public accountOpen: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public isActive(path: string) {
        return location.pathname === path || location.pathname.indexOf(path + '/') === 0;
    }

    public isAdmin() {
        return this.service.auth.session?.role === 'admin';
    }

    public navClass(path: string) {
        return this.isActive(path)
            ? 'text-slate-950 bg-amber-300'
            : 'text-slate-500 hover:text-slate-950 hover:bg-slate-100';
    }

    public async toggleAccount(event: any) {
        event.stopPropagation();
        this.accountOpen = !this.accountOpen;
        await this.service.render();
    }

    @HostListener('document:click')
    public async closeAccount() {
        if (!this.accountOpen) return;
        this.accountOpen = false;
        await this.service.render();
    }

    @HostListener('document:keydown.escape')
    public async closeAccountWithEscape() {
        await this.closeAccount();
    }

    public async logout() {
        this.accountOpen = false;
        await this.service.request.post('/wiz/api/page.access/login', { session_action: 'logout' });
        location.href = '/access';
    }
}

export default LayoutSidebarComponent;